import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analytics-notes export-page" }
const _hoisted_2 = { class: "container-page big analytics-notes__container analytics-notes__print js-analytics-container" }
const _hoisted_3 = { class: "analytics-notes__filter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VedExportButtons = _resolveComponent("VedExportButtons")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_AnalyticsNotesFilter = _resolveComponent("AnalyticsNotesFilter")!
  const _component_AnalyticsNotesBaseInfo = _resolveComponent("AnalyticsNotesBaseInfo")!
  const _component_AnalyticsNotesForeignTrade = _resolveComponent("AnalyticsNotesForeignTrade")!
  const _component_AnalyticsNotesTradeTabSwitcher = _resolveComponent("AnalyticsNotesTradeTabSwitcher")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      title: _ctx.pageTitle,
      dense: ""
    }, {
      button: _withCtx(() => [
        _createVNode(_component_VedExportButtons, {
          disabled: _ctx.getIsDisabledExportButtons,
          loading: _ctx.isExportProgress,
          excelPermissionCode: _ctx.exportPermissionCode,
          onExportExcel: _ctx.exportExcel,
          onExportPdf: _ctx.printPage
        }, null, 8, ["disabled", "loading", "excelPermissionCode", "onExportExcel", "onExportPdf"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AnalyticsNotesFilter, {
          onSearchFilter: _ctx.searchFilter,
          onUpdateFilter: _ctx.updateFilterForExport,
          defaultFilter: _ctx.defaultFilter,
          isMonthly: _ctx.isMonthly,
          readonlyPermissionCode: _ctx.readonlyPermissionCode
        }, null, 8, ["onSearchFilter", "onUpdateFilter", "defaultFilter", "isMonthly", "readonlyPermissionCode"])
      ]),
      _createVNode(_component_AnalyticsNotesBaseInfo, {
        filter: _ctx.normalizedFilter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"]),
      _createVNode(_component_AnalyticsNotesForeignTrade, {
        filter: _ctx.normalizedRequestFilter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"]),
      _createVNode(_component_AnalyticsNotesTradeTabSwitcher, {
        filter: _ctx.normalizedRequestFilter,
        isMonthly: _ctx.isMonthly
      }, null, 8, ["filter", "isMonthly"])
    ])
  ]))
}